<template>
  <a-modal
    :visible="modalVisible"
    @cancel="modalCancel"
    @ok="modalSubmit"
    width="50%"
    cancelText="取消"
    okText="确认"
    title="Coupon distribution"
  >
    <a-form
      ref="formRef"
      :model="form"
      :rules="rules"
      :label-col="{ span: 6 }"
      :wrapper-col="{ span: 16 }"
    >
      <a-form-item label="直播间号" name="liveId">
        <a-select v-model:value="form.liveId" placeholder="请选择" allow-clear>
          <a-select-option
            v-for="(item, index) in liveRoomSelect"
            :key="index"
            :value="item['id']"
            :label="item['chatGroupName']"
          >
            {{ item['chatGroupName'] }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="优惠券优惠金额" name="content">
        <a-input v-model:value="form.content" placeholder="请输入" />
      </a-form-item>
      <a-form-item label="新增优惠券使用门槛">
        <a-button type="dashed" block @click="addContent" style="width: 120px;">
          <PlusOutlined />
        </a-button>
      </a-form-item>
      <a-form-item label="说明">
        <a-space
          v-for="(item, index) in form.remark"
          :key="index"
          style="display: flex; margin-bottom: 8px"
          align="baseline"
        >
          <a-form-item
            :name="['remark', index, 'key']"
            label="语言"
            :rules="{
              required: true,
              message: '请选择语言'
            }"
          >
            <a-select
              v-model:value="item.key"
              :options="langList"
              placeholder="请选择"
            >
            </a-select>
          </a-form-item>
          <a-form-item
            label="优惠券使用门槛"
            :name="['remark', index, 'value']"
            :rules="{
              required: true,
              message: '请输入'
            }"
          >
            <a-textarea
              v-model:value="item.value"
              placeholder="请输入"
              auto-size
            />
          </a-form-item>

          <MinusCircleOutlined @click="removeContent(item)" />
        </a-space>
      </a-form-item>

      <!-- <a-form-item label="优惠券使用门槛" name="remark">
        <a-input v-model:value="form.remark" placeholder="请输入" />
      </a-form-item> -->
      <a-form-item label="券码" name="couponCode">
        <a-input v-model:value="form.couponCode" placeholder="请输入" />
      </a-form-item>
      <a-form-item label="有效期" name="emptyTime">
        <a-range-picker
          v-model:value="form.emptyTime"
          :format="'YYYY-MM-DD'"
          @change="changeRangePicker"
          :placeholder="['开始时间', '结束时间']"
        />
      </a-form-item>
      <a-form-item label="发放规则" name="countDown">
        <a-input-number
          v-model:value="form.countDown"
          placeholder="请输入"
          addon-before="倒计时"
          addon-after="S"
          min="0"
        ></a-input-number>
      </a-form-item>
      <a-form-item label="发送时间" name="sendTime">
        <a-radio-group
          v-model:value="form.sendTimeType"
          name="sendTimeType"
          @change="selectType"
        >
          <a-radio value="1">立刻</a-radio>
          <a-radio value="2">自定义</a-radio>
        </a-radio-group>
        <a-form-item-rest>
          <a-date-picker
            v-model:value="form.sendTime"
            :show-time="{ format: 'HH:mm:ss' }"
            placeholder="请选择日期"
            :disabled="form.sendTimeType != 2"
          />
        </a-form-item-rest>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import { inject, toRefs } from 'vue'
import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons-vue'
export default {
  components: {
    PlusOutlined,
    MinusCircleOutlined
  },
  setup() {
    return {
      ...toRefs(inject('initState'))
    }
  }
}
</script>

<style lang="scss" scoped>
.ant-input[disabled] {
  color: #000;
}
.item {
  text-align: center;
  border: 1px solid #dedede;
  .label {
    padding: 10px 15px;
    white-space: nowrap;
  }
  .value {
    height: 100%;
    white-space: nowrap;
    padding: 10px 15px;
    border-top: 1px solid #dedede;
    .ant-form-item {
      margin: 0;
    }
  }
}
</style>
